// extracted by mini-css-extract-plugin
export default {"body":"body_w6FK9","desc":"desc_SuHwu","images":"images_z0sO3","item":"item_tx4lj"};